import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {tagPropType} from '../utils/helper.js';

//component - CoreUI / CModalFooter

const CModalFooter = props=>{

  const {
    tag: Tag,
    className,
    //
    innerRef,
    ...attributes
  } = props;

  //render

  const classes = classNames(
    className,
    'modal-footer'
  );

  return (
    <Tag className={classes} {...attributes} ref={innerRef} />
  );

}

CModalFooter.propTypes = {
  tag: tagPropType,
  className: PropTypes.string,
  //
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string])
};

CModalFooter.defaultProps = {
  tag: 'footer'
};

export default CModalFooter;
